import { Box, Select, TextField, MenuItem } from '@mui/material';
import {
  ICurrency,
  type IMonetaryValueAttribute,
} from '../../../Interfaces/ILegalTransactionMeasure';
import { currencyOptions } from '../../../Interfaces/ILegalTransactionMeasure';

export const MonetaryValueAttribute = ({
  attribute,
  onUpdateAttribute,
}: {
  attribute: IMonetaryValueAttribute;
  onUpdateAttribute: (attribute: IMonetaryValueAttribute) => void;
}) => {
  const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    // Only allow digits and decimal point
    const value = e.target.value;

    // If the input is empty or a valid decimal number, update the value
    if (value === '' || /^-?\d*\.?\d*$/.test(value)) {
      onUpdateAttribute({
        ...attribute,
        Value: value === '' ? 0 : Number(value),
      });
    }
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <TextField
        sx={{
          minWidth: '300px',
          backgroundColor: 'background.paper',
          '& .MuiInputBase-input': {
            paddingRight: '8px',
          },
          '& .MuiOutlinedInput-notchedOutline': {
            borderTopRightRadius: 0,
            borderBottomRightRadius: 0,
          },
        }}
        fullWidth
        label={attribute.Name}
        size='small'
        required={attribute.Required}
        value={attribute.Value}
        type='number'
        inputProps={{
          step: 'any',
          inputMode: 'decimal',
          pattern: '[0-9]*\\.?[0-9]*',
        }}
        onChange={handleInputChange}
        onKeyDown={e => {
          // Prevent 'e', '+', '-' characters
          if (['e', 'E', '+'].includes(e.key)) {
            e.preventDefault();
          }
        }}
      />

      <Select
        variant='outlined'
        sx={{
          width: '100px',
          marginLeft: '-1px',
          backgroundColor: 'white',
          '& .MuiOutlinedInput-notchedOutline': {
            borderTopLeftRadius: 0,
            borderBottomLeftRadius: 0,
          },
        }}
        size='small'
        value={attribute.CurrencyType}
        onChange={e =>
          onUpdateAttribute({
            ...attribute,
            CurrencyType: e.target.value as ICurrency,
            idCurrencyType:
              currencyOptions.indexOf(e.target.value as ICurrency) + 1,
          })
        }
      >
        {currencyOptions.map(option => (
          <MenuItem key={option} value={option}>
            {option}
          </MenuItem>
        ))}
      </Select>
    </Box>
  );
};
